import React from 'react'
import { Nav, NavLink, NavbarContainer, Span, NavLogo, NavItems, GitHubButton, ButtonContainer, MobileIcon, MobileMenu, MobileNavLogo, MobileLink } from './NavbarStyledComponent'
import { DiCssdeck } from 'react-icons/di';
import { FaBars } from 'react-icons/fa';
import { Bio } from '../../data/constants';
import { Close, CloseRounded } from '@mui/icons-material';
import { useTheme } from 'styled-components';

import H from "./hLogos.png"

const Navbar = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const theme = useTheme()
  return (
    <Nav>
      <NavbarContainer>
        <NavLogo to='/'>
          <a style={{ display: "flex", alignItems: "center", color: "white", marginBottom: '20;', cursor: 'pointer', fontWeight: '600', fontSize: '18px'}}>
            {/* <DiCssdeck size="2.6rem"/>  */}
            {/* <Span>Portfolio</Span> */}
            <img src={H} style={{width: "42px"}} />
            <div style={{ color: 'rgb(133, 76, 230)', fontSize: '32px', fontWeight: '500'  }}>&lt;</div>
            Himanshu
            <div style={{ color: 'rgb(133, 76, 230)', fontSize: '20px', fontWeight: 'bold' }}>/</div>
            Sharma
            <div style={{ color: 'rgb(133, 76, 230)', fontSize: '32px', fontWeight: '500' }}>&gt;</div>
          </a>
        </NavLogo>
        <MobileIcon>
          {!isOpen ? (
              <FaBars onClick={() => setIsOpen(true)} className="close-icon" />
            ) : (
              <Close onClick={() => setIsOpen(false)} className="bars-icon" />
          )}
        </MobileIcon>
        <NavItems>
          <NavLink exact href="#about">About</NavLink>
          <NavLink exact href='#skills'>Skills</NavLink>
          {/* <NavLink href='#experience'>Experience</NavLink> */}
          <NavLink exact href='#projects'>Projects</NavLink>
          <NavLink exact href='#education'>Education</NavLink>
          <NavLink exact href='#contact'>Contact</NavLink>
        </NavItems>
        <ButtonContainer>
          <GitHubButton href={Bio.github} target="_blank">Github Profile</GitHubButton>
        </ButtonContainer>
        {
          isOpen &&
          <MobileMenu isOpen={isOpen}>
            <MobileLink href="#about" onClick={() => {
              setIsOpen(!isOpen)
            }}>About</MobileLink>
            <MobileLink href='#skills' onClick={() => {
              setIsOpen(!isOpen)
            }}>Skills</MobileLink>
            {/* <MobileLink href='#experience' onClick={() => {
              setIsOpen(!isOpen)
            }}>Experience</MobileLink> */}
            <MobileLink href='#projects' onClick={() => {
              setIsOpen(!isOpen)
            }}>Projects</MobileLink>
            <MobileLink href='#education' onClick={() => {
              setIsOpen(!isOpen)
            }}>Education</MobileLink>
            <MobileLink href='#contact' onClick={() => {
              setIsOpen(!isOpen)
            }}>Contact</MobileLink>
            <GitHubButton style={{padding: '10px 16px',background: `${theme.primary}`, color: 'white',width: 'max-content'}} href={Bio.github} target="_blank">Github Profile</GitHubButton>
          </MobileMenu>
        }
      </NavbarContainer>
    </Nav>
  )
}

export default Navbar